// extracted by mini-css-extract-plugin
module.exports = {"assignJobToTeamDialog":"AssignJobToTeamDialog-m__assignJobToTeamDialog___10ysT","warning":"AssignJobToTeamDialog-m__warning___3g0dT"};